var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParameterSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4092F5",
    d: "M15 6V3h2v3h3v12h-3v3h-2v-3h-2v3h-2v-3H9v3H7v-3H4V6h3V3h2v3h2V3h2v3h2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.99 8.18a.586.586 0 0 1 .845 0c.11.107.165.242.165.403a.542.542 0 0 1-.165.404l-5.853 5.762-.074.072a.538.538 0 0 1-.413.179.538.538 0 0 1-.412-.18l-2.918-2.835A.542.542 0 0 1 7 11.58c0-.162.055-.296.165-.404a.586.586 0 0 1 .844 0l2.477 2.423 5.505-5.42z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameterSelected);
export default __webpack_public_path__ + "static/media/parameter-selected.a00200f297655f3978d6a2d07ea48a37.svg";
export { ForwardRef as ReactComponent };